import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import avroom from '../avroom';
import eventHeartbeat from '../eventHeartbeat';
import { default as stage } from '../stage';
import survey from '../surveys';
import textQNA from '../textQNA';
import { getDefaultState } from './types';

const state = getDefaultState && getDefaultState();

export default {
  namespaced: true,
  modules: {
    survey,
    textQNA,
    avroom,
    stage,
    eventHeartbeat
  },
  state,
  getters,
  mutations,
  actions
};
